import { FC, useEffect, useState } from 'react';

import { PaginationContainerStyled, StyledViewOrderIdsTableContainer } from './ViewOrderIds.styles';
import { ViewOrderIdsFilters } from './ViewOrderIdsFilter/ViewOrderIdsFilter.types';
import { ViewOrderIdsProps } from './ViewOrderIds.types';
import { Pagination, PaginationResults } from '@base-app';
import { DEFAULT_PAGE_SIZE } from '@components/constants';

import ViewOrderIdsFilter from './ViewOrderIdsFilter/ViewOrderIdsFilter';
import ViewOrderIdsTable from './ViewOrderIdsTable/ViewOrderIdsTable';

const ViewOrderIds: FC<ViewOrderIdsProps> = ({ collectionLocation, data, isError, isLoading, onChangeParams }) => {
  const pageSize = DEFAULT_PAGE_SIZE;

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [firstItemPage, setFirstItemPage] = useState<number>(0);
  const [lastItemPage, setLastItemPage] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);

  const hasMorePages = data?.meta?.hasMorePages;

  const handleFilterChange = ({ query, dateRange, types }: ViewOrderIdsFilters): void => {
    onChangeParams({
      from: dateRange?.startDate,
      offset: 0,
      query,
      selectedDateRange: dateRange?.selectedDateRange,
      to: dateRange?.endDate,
      sampleType: types,
    });
    setOffset(0);
  };

  const handleChangePage = (offset: number): void => {
    onChangeParams({
      offset,
    });
    setOffset(offset);
  };

  const handleChangeSorting = (sort: Map<string, boolean>): void => {
    onChangeParams({
      offset: 0,
      sort: Object.fromEntries(sort),
    });
    setOffset(0);
  };

  const handlePageChange = (page: number): void => {
    const offset = (page - 1) * pageSize;
    handleChangePage(offset);
  };

  useEffect(() => {
    if (data && offset !== undefined) {
      const firstItem = offset + 1;
      let lastItem = 0;
      if (pageSize > data?.data?.length + 1) {
        lastItem = offset + data.data.length;
      } else {
        lastItem = offset + pageSize;
      }

      setFirstItemPage(firstItem);
      setLastItemPage(lastItem);
      setCurrentPage(offset / pageSize + 1);
    }
  }, [pageSize, data, offset]);

  return (
    <StyledViewOrderIdsTableContainer>
      <ViewOrderIdsFilter collectionLocation={collectionLocation} onFilterChange={handleFilterChange} />
      <ViewOrderIdsTable
        data={data}
        isError={isError}
        isLoading={isLoading}
        offset={offset}
        onChangeSorting={handleChangeSorting}
      />

      {data?.data != null && data.data.length > 0 && (
        <PaginationContainerStyled>
          <PaginationResults range={[firstItemPage, lastItemPage]} />
          <Pagination
            currentPage={currentPage}
            hasMorePages={hasMorePages}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            continuosPagination={true}
          />
        </PaginationContainerStyled>
      )}
    </StyledViewOrderIdsTableContainer>
  );
};

export default ViewOrderIds;
